// extracted by mini-css-extract-plugin
export default {"tooltip":"Icon_tooltip__A5iXL"};